import { atom } from 'jotai'

export enum PerpInfoTabTypes {
  ContractInfo,
  FundingRate,
  InsuranceFund,
}
export const perpInfoTabAtom = atom(PerpInfoTabTypes.ContractInfo)
